@if (allowYoutube()) {
  <iframe
    width="656"
    height="369"
    [src]="safeResourceUrl()"
    [title]="'shared.youtubeEmbed.videoTitle' | transloco"
    frameborder="0"
    allow="
      accelerometer;
      autoplay;
      clipboard-write;
      encrypted-media;
      gyroscope;
      picture-in-picture;
      web-share;
    "
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
    loading="lazy"
    class="max-w-full"
  ></iframe>
} @else if (activateYoutubeError()) {
  <app-error-component
    [enableRetry]="true"
    (clickRetry)="onClickActivateYoutube()"
    class="h-[369px] w-[656px] max-w-full block"
  />
} @else {
  <div
    class="bg-primary-soft dark:bg-primary-soft-darkmode h-[369px] w-[656px] max-w-full rounded-lg flex flex-col gap-3 items-center justify-center text-center"
  >
    <div class="max-w-110">
      <h3 class="text-sm leading-5 font-medium">
        {{ 'shared.youtubeEmbed.privacyTitle' | transloco }}
      </h3>
      <p class="text-sm leading-6">
        {{ 'shared.youtubeEmbed.privacyDescription1' | transloco }}
      </p>
      <p class="text-sm leading-6">
        {{ 'shared.youtubeEmbed.privacyDescription2' | transloco }}
      </p>
    </div>
    <ui-button (click)="onClickActivateYoutube()" [loading]="activateYoutubeLoading()">{{
      'shared.youtubeEmbed.activateButton' | transloco
    }}</ui-button>
  </div>
}
